module.exports = __webpack_public_path__ + "img/logo-whs.9790391a.png";